type ModuleName =
  | "Dealer List"
  | "Dealer Payments"
  | "User"
  | "Roles"
  | "Service History"
  | "Vehicle Crime Report"
  | "RTO Consultancy"
  | "Door Service"
  | "Challan Check"
  | "Photoshoot Service"
  | "Creative Designing"
  | "Social Media"
  | "Vahan Check"
  | "Auction Services"
  | "Auctions Requirement"
  | "Classified Listing"
  | "Dealer Reels"
  | "Inventory Management"
  | "Customer Loans"
  | "Customer Insurance"
  | "Upload Buyer Lead"
  | "Customer Management"
  | "Manage Services";

type PermissionName =
  | "View"
  | "Edit"
  | "Add"
  | "Delete"
  | "Cancel"
  | "Start"
  | "Re-Auction"
  | "Re-bid"
  | "Win"
  | "Show Mobile no"
  | "Call";

const getStoredPermissions = () => {
  try {
    const storedPermissions = localStorage.getItem("permissions");

    if (!storedPermissions) {
      return [];
    }

    const parsedPermissions = JSON.parse(storedPermissions);
    return Array.isArray(parsedPermissions) ? parsedPermissions : [];
  } catch (error) {
    console.error("Failed to parse permissions from storage", error);
    localStorage.removeItem("permissions");
    return [];
  }
};

export const isAllowed = (
  moduleName: ModuleName,
  permissionName: PermissionName,
) => {
  if (localStorage.getItem("roleId") === "7") return true;

  const role = getStoredPermissions();

  return role.some((it) => {
    if (it?.module === moduleName) {
      return it.permission?.includes(permissionName);
    }
    return false;
  });
};

/* Check by exact API submodule name (e.g. "Challan Check", "Notification").
   Returns true if the role has ANY permission at all for that submodule —
   not just a View-like one. A submodule can be granted access via any
   single action (e.g. Notification with only "Edit", Dealer List with only
   "Show Kyc") and the role should still see its sidebar link and be able to
   open its page; the specific action only matters for gating individual
   buttons/fields inside that page (handled separately by isAllowed()). */
export const hasAccess = (submoduleName: string): boolean => {
  if (localStorage.getItem("roleId") === "7") return true;

  const role = getStoredPermissions();
  return role.some(
    (it) => it?.module === submoduleName && (it.permission?.length ?? 0) > 0,
  );
};

export const getUserPermissions = (roles) => {
  const array: Array<any> = [];

  if (!roles || typeof roles !== "object") {
    localStorage.setItem("permissions", JSON.stringify(array));
    return;
  }

  for (const moduleKey in roles) {
    const module = roles[moduleKey];

    if (!module?.submodules) {
      continue;
    }

    for (const submoduleKey in module.submodules) {
      const submodule = module.submodules[submoduleKey];
      const permissionArray: Array<any> = [];

      if (!submodule?.permissions) {
        array.push({ module: submodule?.name, permission: permissionArray });
        continue;
      }

      for (const permissionKey in submodule.permissions) {
        const permission = submodule.permissions[permissionKey];

        if (permission?.action) {
          permissionArray.push(permission.action);
        }
      }

      array.push({ module: submodule?.name, permission: permissionArray });
    }
  }

  localStorage.setItem("permissions", JSON.stringify(array));
};
